<grid-handler-view scope="installations" [panels]="panels" [volumetries]="null" [gridProperties]="gridProperties"
  [editMode]="editMode" [editChangedValues]="editData !== undefined && editData.length > 0"
  [canSave]="editData !== undefined && editData.length > 0" [saving]="savingFlag"
  [subheaderSelector]="subheaderSelector" (onGenerateAction)="generateSheet($event)">
</grid-handler-view>